import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FromNowPipe } from './from-now/from-now.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';

@NgModule({
  declarations: [
    FromNowPipe,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FromNowPipe,
    SafeHtmlPipe
  ]
})
export class PipesModule { }
